module.exports = __webpack_public_path__ + "img/flow.98a1fca1.svg";